import React, { useState } from 'react';
import PropTypes from 'prop-types';

import TemplateDefault from '../../templates/default/default';
import Stage from '../../organisms/stage/stage';
import ContentBlocks from '../../organisms/content-blocks/contentBlocks.withRedux';
import Pagination from '../../organisms/pagination/pagination';
import RoomOfQuestions from '../../organisms/room-of-questions/roomOfQuestions';

import FloorPlan from '../../organisms/floor-plan/floorPlan';

import getPageModule from '../../utility/getPageModule';

const ThinkingSpace = ({
  data: {
    curatedExhibitionTeasers,
    curatedExhibitionSubheadline,
    pageModules,
    meta,
    floorPlanDataUrl,
    roomOfQuestions
  }
}) => {
  const [isRoomOfQuestionsOpen, setIsRoomOfQuestionsOpen] = useState(true);
  return (
    <TemplateDefault>
      <Stage
        curatedExhibitionTeasers={curatedExhibitionTeasers}
        curatedExhibitionSubheadline={curatedExhibitionSubheadline}
      />

      <ContentBlocks noShareLinks hasCuratedExhibitionTeasers={!!curatedExhibitionTeasers} />
      <FloorPlan dataUrl={floorPlanDataUrl} />

      {roomOfQuestions && roomOfQuestions.questions && roomOfQuestions.questions.length > 0 && (
        <RoomOfQuestions
          questions={roomOfQuestions.questions}
          isOpen={isRoomOfQuestionsOpen}
          onClose={() => setIsRoomOfQuestionsOpen(false)}
        />
      )}

      {pageModules.length > 0 &&
        pageModules.map((block, index) => getPageModule(block, index)[block.type])}

      {meta && meta.pagination && meta.pagination.total_pages > 1 && (
        <Pagination
          pageType="thinkingSpace"
          totalPages={parseInt(meta.pagination.total_pages, 10)}
          currentPage={parseInt(meta.pagination.current_page, 10)}
        />
      )}
    </TemplateDefault>
  );
};

ThinkingSpace.propTypes = {
  data: PropTypes.shape({
    curatedExhibitionTeasers: PropTypes.shape(),
    curatedExhibitionSubheadline: PropTypes.string,
    pageModules: PropTypes.arrayOf([PropTypes.shape]),
    meta: PropTypes.shape({
      pagination: PropTypes.shape()
    }),
    floorPlanDataUrl: PropTypes.string.isRequired,
    roomOfQuestions: PropTypes.shape()
  })
};

export default ThinkingSpace;
